<button class="light-blue-text back-btn" mat-icon-button (click)="peruuta()" type="button">
  <i class="icon ion-md-arrow-back"></i>
</button>

@if (tositeObservable | async; as tosite) {
  <div class="maksut-katsele-page">
    @if (viewTypeObservable | async; as viewType) {
      <div class="left-container">
        @if (pagesObservable | async; as pages) {
          <div class="header">
            <button [style.visibility]="pages.curr > 1 ? 'visible' : 'hidden'" mat-button (click)="navigoiEdelliseen()">
              <i class="navigation-icon fa fa-chevron-left"></i>
            </button>
            <div style="text-align: center; line-height: 36px">{{ 'maksut.katsele.lasku' | translate | async }} {{ pages.curr }} / {{ pages.total }}</div>
            <button [style.visibility]="pages.curr < pages.total ? 'visible' : 'hidden'" mat-button (click)="navigoiSeuraavaan()">
              <i class="navigation-icon fa fa-chevron-right"></i>
            </button>
          </div>
        }
        <!-- <div style="text-align: right;" *ngIf="viewType === 'hyvaksynta' || viewType === 'hyvaksynta-ja-maksaminen'">
        <div *ngIf="maksuHyvaksyttyObservable | async; else odottaaHyvaksyntaa">
          <span><i class="ion-ios-checkmark green-text" style="vertical-align: middle; font-size: 2em; padding-right: 3px;"></i></span>
          {{ 'maksut.katsele.hyvaksytty' | translate | async}}
        </div>
        <ng-template #odottaaHyvaksyntaa>
          <div>
            <span style="color: inherit;"> <i class="icon fa fa-clock-o"></i></span>
            {{ 'maksut.katsele.odottaa-hyvaksyntaa' | translate | async}}
          </div>
        </ng-template>
      </div> -->
        <div style="margin-top: 2em">
          <h2>{{ tosite.seller }}</h2>
          <form>
            <div class="tiedot-row">
              <div class="left-col">{{ 'maksut.muokkaa.toimittaja' | translate | async }}</div>
              @if (tositteenToimittajaObservable | async; as tositteenToimittaja) {
                @if (maksunTiedotLomake.toimittaja().disabled()) {
                  <div class="right-col" style="position: relative">
                    <div class="toimittaja-numero">
                      {{ tositteenToimittaja.numero }}
                    </div>
                    {{ tositteenToimittaja.nimi }}
                  </div>
                }
              }
              @if (!maksunTiedotLomake.toimittaja().disabled()) {
                <div class="right-col">
                  <mat-form-field>
                    @if (valittuToimittaja) {
                      <div class="toimittaja-numero">
                        {{ valittuToimittaja.numero }}
                      </div>
                    }
                    <mat-label>{{ 'maksut.muokkaa.toimittaja' | translate | async }}</mat-label>
                    <input #toimittajaVar="matInput" type="text" autocomplete="kirjnpitomekiarki" [matAutocomplete]="toimittajaAuto" [formField]="maksunTiedotLomake.toimittaja" (paste)="onToimittajaPaste($event)" matInput data-lpignore="true" />
                    @if (valittuToimittaja) {
                      <i style="cursor: pointer; font-size: 30px" matSuffix class="icon ion-ios-close" (click)="poistaValittuToimittaja()"></i>
                    }
                    @if ((toimittajaVar?.ngControl?.dirty || toimittajaVar?.ngControl?.touched) && toimittajaVar.ngControl?.errors?.required) {
                      <mat-error>{{ 'maksut.muokkaa.validation.toimittaja.required' | translate | async }}</mat-error>
                    }
                    @if (toimittajahaunVihjetekstiObservable | async; as toimittajahaunVihjeteksti) {
                      <mat-hint>
                        <mat-icon style="font-size: calc(100% + 4px); position: absolute; top: 4px; left: -4px" class="green-text">done</mat-icon>
                        <span style="display: inline-block; width: 14px"></span>
                        <span>{{ toimittajahaunVihjeteksti }}</span>
                      </mat-hint>
                    }
                  </mat-form-field>
                  <mat-autocomplete #toimittajaAuto="matAutocomplete" [displayWith]="toimittajaDisplayFn" [panelWidth]="350">
                    @for (toimittaja of suodatetutToimittajat | async; track toimittaja) {
                      <mat-option [value]="toimittaja"> {{ toimittaja.numero }} {{ toimittaja.nimi }} {{ toimittaja.ytunnus ? `(${naytettavaTunniste(toimittaja.ytunnus)})` : '' }} </mat-option>
                    }
                  </mat-autocomplete>
                </div>
              }
            </div>
            <div class="tiedot-row">
              <div class="left-col">{{ 'maksut.katsele.saaja' | translate | async }}</div>
              @if (maksunTiedotLomake.saaja().disabled()) {
                <div class="right-col">{{ tosite.maksutiedot?.maksunSaajanNimi ?? tosite.seller ?? '' }}</div>
              }
              @if (!maksunTiedotLomake.saaja().disabled()) {
                <mat-form-field class="right-col">
                  <mat-label>{{ 'maksut.muokkaa.saaja' | translate | async }}</mat-label>
                  <input matInput class="alignLeft" #saajaVar="matInput" [formField]="maksunTiedotLomake.saaja" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
                  @if ((saajaVar?.ngControl?.dirty || saajaVar?.ngControl?.touched) && saajaVar.ngControl?.errors?.required) {
                    <mat-error>{{ 'maksut.muokkaa.validation.saaja.required' | translate | async }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>
            <div class="tiedot-row">
              <div class="left-col">{{ 'maksut.muokkaa.iban' | translate | async }}</div>
              @if (maksunTiedotLomake.iban().disabled()) {
                <div class="right-col">{{ formattedIban() }}</div>
              }
              @if (!maksunTiedotLomake.iban().disabled()) {
                <mat-form-field class="right-col">
                  <mat-label>{{ 'maksut.muokkaa.iban' | translate | async }}</mat-label>
                  <input matInput class="alignLeft" #ibanVar="matInput" [formField]="maksunTiedotLomake.iban" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
                  @if ((ibanVar?.ngControl?.dirty || ibanVar?.ngControl?.touched) && ibanVar.ngControl?.errors?.required) {
                    <mat-error>{{ 'maksut.muokkaa.validation.iban.required' | translate | async }}</mat-error>
                  }
                  @if ((ibanVar?.ngControl?.dirty || ibanVar?.ngControl?.touched) && ibanVar.ngControl?.errors?.invalidiban) {
                    <mat-error>{{ 'maksut.muokkaa.validation.iban.invalid' | translate | async }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>
            <div class="tiedot-row">
              <div class="left-col">{{ 'maksut.muokkaa.bic' | translate | async }}</div>
              @if (maksunTiedotLomake.bic().disabled()) {
                <div class="right-col">{{ tosite.maksutiedot?.bic ?? tosite.bic ?? '' }}</div>
              }
              @if (!maksunTiedotLomake.bic().disabled()) {
                <mat-form-field class="right-col">
                  <mat-label>{{ 'maksut.muokkaa.bic' | translate | async }}</mat-label>
                  <input matInput class="alignLeft" #bicVar="matInput" [formField]="maksunTiedotLomake.bic" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
                  @if ((bicVar?.ngControl?.dirty || bicVar?.ngControl?.touched) && bicVar.ngControl?.errors?.required) {
                    <mat-error>{{ 'maksut.muokkaa.validation.bic.required' | translate | async }}</mat-error>
                  }
                  @if ((bicVar?.ngControl?.dirty || bicVar?.ngControl?.touched) && bicVar.ngControl?.errors?.invalidbic) {
                    <mat-error>{{ 'maksut.muokkaa.validation.bic.invalid' | translate | async }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>
            <div class="tiedot-row">
              <div class="left-col">{{ 'maksut.katsele.viitenumero' | translate | async }}</div>
              @if (maksunTiedotLomake.viite().disabled()) {
                <div class="right-col">{{ tosite.maksutiedot?.reference ?? tosite.viitenumero ?? '' }}</div>
              }
              @if (!maksunTiedotLomake.viite().disabled()) {
                <mat-form-field class="right-col">
                  <mat-label>{{ 'maksut.muokkaa.viite' | translate | async }}</mat-label>
                  <input matInput class="alignLeft" #viiteVar="matInput" [formField]="maksunTiedotLomake.viite" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
                  @if ((viiteVar?.ngControl?.dirty || viiteVar?.ngControl?.touched) && viiteVar.ngControl?.errors?.viitenumero) {
                    <mat-error>{{ 'maksut.muokkaa.validation.viite.viitenumero' | translate | async }}</mat-error>
                  }
                  @if ((viiteVar?.ngControl?.dirty || viiteVar?.ngControl?.touched) && viiteVar.ngControl?.errors?.viestitaiviite) {
                    <mat-error>{{ 'maksut.muokkaa.validation.viite.viite-tai-viesti' | translate | async }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>
            <div class="tiedot-row" style="height: initial">
              <div class="left-col">{{ 'maksut.katsele.viesti' | translate | async }}</div>
              @if (maksunTiedotLomake.viesti().disabled()) {
                <div class="right-col">{{ tosite.maksutiedot?.message ?? '' }}</div>
              }
              @if (!maksunTiedotLomake.viesti().disabled()) {
                <mat-form-field class="right-col">
                  <textarea matInput #viestiVar="matInput" [formField]="maksunTiedotLomake.viesti" cdkTextareaAutosize cdkAutosizeMinRows="2" autocomplete="kirjnpitomekiarki" data-lpignore="true"></textarea>
                  @if ((viestiVar?.ngControl?.dirty || viestiVar?.ngControl?.touched) && viestiVar.ngControl?.errors?.viestitaiviite) {
                    <mat-error>{{ 'maksut.muokkaa.validation.viite.viite-tai-viesti' | translate | async }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>
            <div class="tiedot-row">
              <div class="left-col">{{ 'maksut.katsele.erapvm' | translate | async }}</div>
              @if (maksunTiedotLomake.erapvm().disabled()) {
                <div class="right-col">{{ tosite.maksutiedot?.dueDate ?? tosite.dueDate | lnumberpvm | async }}</div>
              }
              @if (!maksunTiedotLomake.erapvm().disabled()) {
                <mat-form-field class="right-col">
                  <input matInput #erapvmVar="matInput" [formField]="maksunTiedotLomake.erapvm" numberDatePicker [matDatepicker]="picker" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
                  @if ((erapvmVar?.ngControl?.dirty || erapvmVar?.ngControl?.touched) && erapvmVar.ngControl?.errors?.required) {
                    <mat-error>{{ 'maksut.muokkaa.validation.erapvm.required' | translate | async }}</mat-error>
                  }
                  @if ((erapvmVar?.ngControl?.dirty || erapvmVar?.ngControl?.touched) && erapvmVar.ngControl?.errors?.matDatepickerParse) {
                    <mat-error>{{ 'maksut.muokkaa.validation.erapvm.matDatepickerParse' | translate | async }}</mat-error>
                  }
                  @if ((erapvmVar?.ngControl?.dirty || erapvmVar?.ngControl?.touched) && erapvmVar.ngControl?.errors?.matDatepickerMax) {
                    <mat-error>{{ 'maksut.muokkaa.validation.erapvm.matDatepickerMax' | translate | async }}</mat-error>
                  }
                  @if ((erapvmVar?.ngControl?.dirty || erapvmVar?.ngControl?.touched) && erapvmVar.ngControl?.errors?.matDatepickerMin) {
                    <mat-error>{{ 'maksut.muokkaa.validation.erapvm.matDatepickerMin' | translate | async }}</mat-error>
                  }
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              }
            </div>
            <!--
          <div class="tiedot-row">
            <div class="left-col">{{ 'maksut.katsele.tililta' | translate | async }}</div>
            <mat-form-field class="right-col">
              <mat-select formControlName="tililta" style="width: 100%;" required>
                <mat-option *ngFor="let iban of tililtaIbanitObservable | async" [value]="iban">
                  {{ iban }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div> -->
            <div class="tiedot-row">
              <div class="left-col">{{ 'maksut.katsele.summa' | translate | async }}</div>
              @if (maksunTiedotLomake.summa().disabled()) {
                <div class="right-col">{{ tosite.maksutiedot?.amount ?? tosite.sum | lmoney: tosite.currency | async }}</div>
              }
              @if (!maksunTiedotLomake.summa().disabled()) {
                <mat-form-field class="right-col">
                  <input matInput #summaVar="matInput" decimalNumberField [formField]="maksunTiedotLomake.summa" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
                  @if ((summaVar?.ngControl?.dirty || summaVar?.ngControl?.touched) && summaVar.ngControl?.errors?.required) {
                    <mat-error>{{ 'maksut.muokkaa.validation.summa.required' | translate | async }}</mat-error>
                  }
                  @if ((summaVar?.ngControl?.dirty || summaVar?.ngControl?.touched) && summaVar.ngControl?.errors?.min) {
                    <mat-error>{{ 'maksut.muokkaa.validation.summa.min' | translate | async }}</mat-error>
                  }
                  @if ((summaVar?.ngControl?.dirty || summaVar?.ngControl?.touched) && summaVar.ngControl?.errors?.max) {
                    <mat-error>{{ 'maksut.muokkaa.validation.summa.max' | translate | async }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>
            <div class="tiedot-row" style="margin-bottom: 0">
              <div class="left-col">{{ 'maksut.katsele.lisatiedot' | translate | async }}</div>
              <mat-form-field class="right-col">
                <textarea matInput [formField]="maksunTiedotLomake.lisatiedot" cdkTextareaAutosize cdkAutosizeMinRows="2" (blur)="saveLisatiedotChange(tosite)" autocomplete="kirjnpitomekiarki" data-lpignore="true"></textarea>
                @if (showLisatiedotCheckMark()) {
                  <mat-hint><i class="icon ion-ios-checkmark-outline green-text" style="font-size: 22px; margin-right: 5px; vertical-align: middle"></i>{{ 'maksut.katsele.tallennettu' | translate | async }}</mat-hint>
                }
              </mat-form-field>
            </div>
            @if (naytaProjektitObservable | async) {
              <div class="tiedot-row">
                <div class="left-col">{{ 'maksut.katsele.projekti' | translate | async }}</div>
                @if (maksunTiedotLomake.projekti().disabled()) {
                  @if (tositteenProjektiObservable | async; as tositteenProjekti) {
                    <div class="right-col">{{ tositteenProjekti.nimi }}</div>
                  } @else {
                    <div class="right-col"></div>
                  }
                }
                @if (!maksunTiedotLomake.projekti().disabled()) {
                  <mat-form-field class="right-col">
                    <mat-label>{{ 'maksut.katsele.projekti' | translate | async }}</mat-label>
                    <mat-select [formField]="maksunTiedotLomake.projekti" [compareWith]="compareProjektit">
                      <mat-option [value]="null">{{ 'maksut.katsele.ei-projektia' | translate | async }}</mat-option>
                      @for (projekti of naytettavatProjektitObservable | async; track projekti.avain) {
                        <mat-option [value]="projekti">{{ projekti.nimi }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </div>
            }
            @if (onkoSuoriteTaiLaskuperusteinenObservable | async) {
              <div class="tiedot-row">
                <div class="left-col">{{ 'maksut.katsele.toimituspaivamaara' | translate | async }}</div>
                @if (maksunTiedotLomake.toimituspvm().disabled()) {
                  <div class="right-col">{{ tosite.deliveryDate | lnumberpvm | async }}</div>
                }
                @if (!maksunTiedotLomake.toimituspvm().disabled()) {
                  <mat-form-field class="right-col">
                    <input matInput class="alignLeft" #toimituspvmVar="matInput" [formField]="maksunTiedotLomake.toimituspvm" [matDatepicker]="deliveryDatePicker" autocomplete="kirjnpitomekiarki" data-lpignore="true" />
                    @if ((toimituspvmVar?.ngControl?.dirty || toimituspvmVar?.ngControl?.touched) && toimituspvmVar.ngControl?.errors?.matDatepickerParse) {
                      <mat-error>{{ 'maksut.muokkaa.validation.toimituspvm.matDatepickerParse' | translate | async }}</mat-error>
                    }
                    @if ((toimituspvmVar?.ngControl?.dirty || toimituspvmVar?.ngControl?.touched) && toimituspvmVar.ngControl?.errors?.matDatepickerMax) {
                      <mat-error>{{ 'maksut.muokkaa.validation.toimituspvm.matDatepickerMax' | translate | async }}</mat-error>
                    }
                    @if ((toimituspvmVar?.ngControl?.dirty || toimituspvmVar?.ngControl?.touched) && toimituspvmVar.ngControl?.errors?.matDatepickerMin) {
                      <mat-error>{{ 'maksut.muokkaa.validation.toimituspvm.matDatepickerMin' | translate | async }}</mat-error>
                    }
                    <mat-datepicker-toggle matSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #deliveryDatePicker></mat-datepicker>
                  </mat-form-field>
                }
              </div>
            }
            @if (maksuaMuokataanObservable | async) {
              <div style="padding-top: 0; padding-bottom: 1em" class="tiedot-row">
                <div class="left-col"></div>
                <div class="right-col" style="text-align: right">
                  <button (click)="cancelPaymentDetailsChanges(tosite)" mat-button class="secondarybutton">{{ 'yleiset.peruuta' | translate | async }}</button>
                  <button mat-button (click)="savePaymentDetailsChanges(tosite)" style="margin-left: 0.5em" class="secondarybutton">{{ 'yleiset.tallenna' | translate | async }}</button>
                </div>
              </div>
            }
          </form>
        </div>
        @if (!(maksuaMuokataanObservable | async)) {
          <div class="buttons">
            @if (naytaHyvaksyNappiObservable | async) {
              <button mat-button (click)="approvePayment()" class="primarybutton">{{ 'maksut.katsele.hyvaksy-lasku' | translate | async }}</button>
            }
            @if (naytaHyvaksynnanPeruminenNappiObservable | async) {
              <button mat-button (click)="revokePaymentApproval(tosite)" class="secondarybutton">{{ 'maksut.katsele.peru-hyvaksynta' | translate | async }}</button>
            }
            @if (naytaMaksettuMuuallaNappiVainVastaanottoObservable | async) {
              <button mat-button (click)="maksettuYrityksenTililtaVainVastaanotto(tosite)" class="primarybutton">{{ 'maksut.katsele.maksettu-yrityksen-tililta' | translate | async }}</button>
            }
            @if (naytaMaksettuMuuallaNappiVainVastaanottoObservable | async) {
              <button mat-button (click)="maksettuOmallaRahallaVainVastaanotto(tosite)" class="secondarybutton">{{ 'maksut.katsele.maksettu-muualla' | translate | async }}</button>
            }
            @if (naytaMaksettuMuuallaNappiMaksutKaytossaObservable | async) {
              <button mat-button (click)="maksettuMuuallaMaksutKaytossa(tosite)" class="secondarybutton">{{ 'maksut.katsele.maksettu-muualla' | translate | async }}</button>
            }
            @if (naytaHylkaaNappiObservable | async) {
              <button mat-button (click)="rejectPayment(tosite)" class="secondarybutton">{{ 'maksut.katsele.hylkaa-lasku' | translate | async }}</button>
            }
            @if (naytaHylkaamisenPeruminenNappiObservable | async) {
              <button mat-button (click)="rejectPaymentPeru(tosite)" class="secondarybutton">{{ 'maksut.katsele.hylkaa-lasku-peru' | translate | async }}</button>
            }
            @if (naytaMaksettuMuuallaPeruminenNappiObservable | async) {
              <button mat-button (click)="maksettuToisaallaPeru(tosite)" class="secondarybutton">{{ 'maksut.katsele.maksettu-muualla-peru' | translate | async }}</button>
            }
            @if (naytaKasiteltyNappiObservable | async) {
              <button mat-button (click)="merkitseKasitellyksi(tosite)" class="secondarybutton">{{ 'maksut.katsele.kasitelty' | translate | async }}</button>
            }
            @if (naytaKasittelynPeruminenNappiObservable | async) {
              <button mat-button (click)="maksettuToisaallaPeru(tosite)" class="secondarybutton">{{ 'maksut.katsele.kasitelty-peru' | translate | async }}</button>
            }
            @if (naytaMerkitseHyvitetyksiNappiObservable | async) {
              <button mat-button (click)="merkitseKasitellyksi(tosite)" class="secondarybutton">{{ 'maksut.katsele.merkitse-hyvitykseksi' | translate | async }}</button>
            }
            @if (naytaMerkitseHyvitetyksiPeruminenNappiObservable | async) {
              <button mat-button (click)="maksettuToisaallaPeru(tosite)" class="secondarybutton">{{ 'maksut.katsele.merkitse-hyvitykseksi-peru' | translate | async }}</button>
            }
            @if (naytaMuokkaaMaksuaNappiObservable | async) {
              <button (click)="setMaksuaMuokataan(true)" mat-button class="secondarybutton">{{ 'maksut.katsele.muokkaa-tietoja' | translate | async }}</button>
            }
            <button mat-button (click)="lataaLasku(tosite)" class="secondarybutton">{{ 'maksut.katsele.lataa-lasku' | translate | async }}</button>
          </div>
        }
        @if (logItemsObservable | async; as logItems) {
          @if (logItems?.virheet?.length) {
            <div style="padding-top: 20px">
              @for (log of logItems.virheet; track log) {
                <div style="display: flex; align-items: center; line-height: 30px"><i [class]="log.icon" style="font-size: 25px; padding-right: 10px; color: red"></i>{{ log.text }}</div>
              }
            </div>
          }
          @if (logItems?.hyvaksynnat?.length) {
            <div style="padding-top: 20px">
              @for (log of logItems.hyvaksynnat; track log) {
                <div style="line-height: 30px; height: 30px" [class.dark-gray-text]="log.placeholder" [class.placeholder]="log.placeholder"><i class="ion-ios-checkmark" style="vertical-align: middle; font-size: 30px; padding-right: 5px"></i>{{ log.text }}</div>
              }
            </div>
          }
        }
        @if (viewType === 'vastaanotto' && kooditObservable | async; as koodit) {
          <div style="margin-top: 4em">
            @if (koodit.qr || koodit.viiva) {
              <div>
                <h2>{{ 'maksut.maksukoodit' | translate | async }}</h2>
                <mat-tab-group #tabgroup [(selectedIndex)]="activeTabIndex" style="min-height: 300px" (selectedIndexChange)="tabGroupIndexChanged($event)" animationDuration="0ms">
                  @if (koodit.qr) {
                    <mat-tab [label]="'maksut.qr-koodi' | translate | async">
                      <ng-template matTabContent>
                        <div class="padded" lemon-qrcode style="max-width: 200px" [qrcodeValue]="koodit.qr"></div>
                      </ng-template>
                    </mat-tab>
                  }
                  @if (koodit.viiva) {
                    <mat-tab [label]="'maksut.viivakoodi' | translate | async">
                      <ng-template matTabContent>
                        <div class="padded" lemon-barcode barcodeCssClass="maksut-katsele-barcode" [barcodeValue]="koodit.viiva"></div>
                      </ng-template>
                    </mat-tab>
                  }
                  @if (koodit.viiva) {
                    <mat-tab [label]="'maksut.virtuaalinen-viivakoodi' | translate | async">
                      <ng-template matTabContent>
                        <div style="padding: 20px 10px">{{ koodit.viiva }}</div>
                      </ng-template>
                    </mat-tab>
                  }
                </mat-tab-group>
              </div>
            }
          </div>
        }
      </div>
    }
    <div class="tosite-sivut">
      @for (kuva of kuvat(); track kuva) {
        <div>
          <div app-tosite-kuva [url]="kuva" class="mat-elevation-z4" style="width: 100%; min-height: 100px; margin-bottom: 15px; overflow-y: hidden; position: relative; border-radius: 2px"></div>
        </div>
      }
    </div>
  </div>
}
